<template>
    <div class="lesson-answer-sheet">
        <h3 class="title">Antwoordenblad - {{ titleIn }}</h3>
        <div
            class="download-sheet"
            v-if="filesIn.length === 1">
            Download
            <a
                class="lesson-attachment"
                :href="filesIn[0].path"
                target="_blank">
                hier
            </a>
            het antwoordblad met de antwoorden bij alle kennisvragen in het werkmagazine.
        </div>

        <ul
            class="attachments-list"
            v-else>
            Download hieronder de antwoordbladen met de antwoorden bij alle kennisvragen in het werkmagazine
            <li
                class="attachment-item"
                v-for="file in filesIn"
                :key="file.id">
                <a
                    class="lesson-attachment"
                    :href="file.path"
                    target="_blank">
                </a>
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    name: 'design-2021-lesson-manual-lesson-answer-sheet-component',
    props: {
        filesIn: {
            type: Array,
            required: true,
        },
        titleIn: {
            type: String,
            required: true,
        },
    },
};
</script>

<style scoped lang="scss"></style>
